"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createErrorEvent;

var _createCustomEvent = _interopRequireDefault(require("./createCustomEvent"));

function createErrorEvent(error) {
  return (0, _createCustomEvent["default"])('error', {
    error: error
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jcmVhdGVFcnJvckV2ZW50LmpzIl0sIm5hbWVzIjpbImNyZWF0ZUVycm9yRXZlbnQiLCJlcnJvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBRWUsU0FBU0EsZ0JBQVQsQ0FBMEJDLEtBQTFCLEVBQWlDO0FBQzlDLFNBQU8sbUNBQWtCLE9BQWxCLEVBQTJCO0FBQUVBLElBQUFBLEtBQUssRUFBTEE7QUFBRixHQUEzQixDQUFQO0FBQ0QiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgY3JlYXRlQ3VzdG9tRXZlbnQgZnJvbSAnLi9jcmVhdGVDdXN0b21FdmVudCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZUVycm9yRXZlbnQoZXJyb3IpIHtcbiAgcmV0dXJuIGNyZWF0ZUN1c3RvbUV2ZW50KCdlcnJvcicsIHsgZXJyb3IgfSk7XG59XG4iXX0=